import classNames from "classnames";
import React from "react";
import { useSearchParams } from "react-router-dom";

import Input from "@atoms/Input";

import { COLLECTION_SORT, SEARCH_SORT, VIEW_OPTIONS } from "@const/constant";

import useCheckLocation from "@hooks/useCheckLocation";

export default function Sort() {
  const [searchParams, setSearchParams] = useSearchParams();

  const { isCollection, isArchive } = useCheckLocation();

  const sortOptions = isCollection ? COLLECTION_SORT : SEARCH_SORT;

  // 파라미터가 없거나 목록에 없는 값이면 첫 번째 옵션이 기본값
  const selectedSort = sortOptions.find((option) => option.name === searchParams.get("sort")) || sortOptions[0];
  const selectedView = searchParams.get("view") === "combined" ? "combined" : "seperate";

  const handleChange = (key: "sort" | "view", value: string) => {
    window.scrollTo({ top: 0 });
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set(key, value);
      return next;
    });
  };

  return (
    <div className={classNames("flex flex-col", isCollection ? "gap-10" : "gap-5")}>
      <div className="flex flex-col gap-2.5">
        <span>Sort By</span>
        <div className="pc:gap-1.5 flex flex-col gap-2">
          {sortOptions.map((option) => (
            <Input
              checked={selectedSort?.name === option.name}
              className="items-center!"
              id={option.label}
              innerClassName="mt-0!"
              key={option.label}
              label={option.label}
              name="sortOption"
              onChange={() => {
                if (selectedSort?.name === option.name) return;
                handleChange("sort", option.name);
              }}
              type="radio"
              value={option.name}
            />
          ))}
        </div>
      </div>

      {!isArchive && (
        <div className="flex flex-col gap-2">
          <span>{isCollection ? "Color Display" : "View Colors"}</span>
          {VIEW_OPTIONS.map((option) => (
            <Input
              checked={selectedView === option.value}
              id={option.id}
              key={option.id}
              label={option.label}
              name="viewOption"
              onChange={() => {
                if (selectedView === option.value) return;
                handleChange("view", option.value);
              }}
              type="radio"
              value={option.value}
            />
          ))}
        </div>
      )}
    </div>
  );
}
